<script lang="ts">
    import { Image, Input } from "sveltestrap";
    import PrintPreview from "./PrintPreview.svelte";
    import ContactHistory from "./ContactHistory.svelte";
    import ContactRemove from "./ContactRemove.svelte";
    import ContactEdit from "./ContactEdit.svelte";
    import ProfileEmailGeneral from "./ProfileEmailGeneral.svelte";
    let imgPath:string ="/assets/images/user"
    export let userItem
    export let index:number
</script>
<div class="profile-mail">
    <div class="media">
        <Image fluid class="img-100 m-r-20 rounded-circle update_img_0" src="{imgPath}/2.png" alt="" />
        <Input class="updateimg" type="file" name="img" />
        <div class="media-body mt-0">
            <h5>
                <span class="first_name_0">{userItem.fname}</span>
                <span class="last_name_0">{userItem.lname}</span>
            </h5>
            <p class="email_add_0">{userItem.email}</p>
            <ul>
                <ContactEdit getId={index}/>
                <ContactRemove getId={index}/>
                <ContactHistory />
                <PrintPreview getId={index}/>
            </ul>
        </div>
    </div>
    <ProfileEmailGeneral userItem={userItem} />
</div>